import styles from "./Sale.module.scss";
import "./slider.css";

export default function Sale() {
  return (
    <>
      <div className={styles.header}>Aktualne promocje</div>
      <p style={{ marginTop: "10px" }}>Brak promocji</p>
    </>
  );
}
